"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-background py-4 relative z-10 navbar">
      <div className="container flex items-center justify-between">
        <Link href="/" className="flex items-center">
          <span className="text-2xl font-medium text-[#9c5f2f] logoText">OnlyLife</span>
        </Link>

        {/* Mobile menu button */}
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {isMenuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6">
          <Link href="/quiz/lose-weight" className="text-foreground/80 hover:text-foreground transition-colors">
            Weight Loss
          </Link>
          <Link href="/quiz/better-sex" className="text-foreground/80 hover:text-foreground transition-colors">
            Better Sex
          </Link>
          <Link href="/quiz/better-hair" className="text-foreground/80 hover:text-foreground transition-colors">
            Hair Regrowth
          </Link>
          <Link href="/quiz/smooth-skin" className="text-foreground/80 hover:text-foreground transition-colors">
            Skin Care
          </Link>
          <Link href="/quiz/tackle-anxiety" className="text-foreground/80 hover:text-foreground transition-colors">
            Tackle Anxiety
          </Link>
          <div className="ml-4">
            <Link
              href="/quiz"
              className="btn btn-primary"
            >
              Get Started
            </Link>
          </div>
        </nav>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-background border-t border-border md:hidden">
            <div className="container py-4 flex flex-col space-y-4">
              <Link
                href="/quiz/lose-weight"
                className="text-foreground/80 hover:text-foreground transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Weight Loss
              </Link>
              <Link
                href="/quiz/better-sex"
                className="text-foreground/80 hover:text-foreground transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Better Sex
              </Link>
              <Link
                href="/quiz/better-hair"
                className="text-foreground/80 hover:text-foreground transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Hair Regrowth
              </Link>
              <Link
                href="/quiz/smooth-sex"
                className="text-foreground/80 hover:text-foreground transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Skin Care
              </Link>
              <Link
                href="/quiz/tackle-anxiety"
                className="text-foreground/80 hover:text-foreground transition-colors py-2"
                onClick={() => setIsMenuOpen(false)}
              >
                Tackle Anxiety
              </Link>
              <div className="pt-2">
                <Link
                  href="/quiz"
                  className="btn btn-primary w-full justify-center"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
